import { useTranslator } from "context/translator";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useGetUserByIdQuery } from "store/api/apiSlice";
import { downloadFileToAzureVersion2 } from "utils/azure/azure";

const FileInput = ({ label, files, onAdd, onRemove }) => {
  const { translate } = useTranslator();
  const { user } = useSelector((state) => state.user);
  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [imageToView, setImageToView] = useState(null);
  const [documentToView, setDocumentToView] = useState(null);

  const toggleModal = async (file) => {
    if (!file) {
      setModalOpen((prev) => !prev);
      return;
    }

    if (file.type.includes("image")) {
      const fileLink = await getImageLink(file);

      setDocumentToView(null);
      setImageToView(fileLink);
      setModalOpen((prev) => !prev);
    } else {
      const fileLink = await getImageLink(file);

      setImageToView(null);
      setDocumentToView(fileLink);
      setModalOpen((prev) => !prev);
    }
  };

  const getImageLink = async (url) => {
    const fileLink = await downloadFileToAzureVersion2(url, userProfile?.user);

    return fileLink;
  };

  if (userLoading) return null;

  return (
    <div className="space-y-2">
      <label className="label">{label}</label>

      <input
        type="file"
        multiple
        onChange={(e) => onAdd(Array.from(e.target.files))}
        className="input"
      />

      {files.length > 0 && (
        <ul className="space-y-1">
          {files.map((file, idx) => (
            <li
              key={idx}
              className="flex items-center justify-between text-sm bg-gray-100 dark:bg-gray-800 p-2 rounded"
            >
              <span className="truncate text-black dark:text-white">
                {file.name}
              </span>
              <div>
                {file?.url && (
                  <button
                    type="button"
                    className="mr-4 text-blue-500"
                    onClick={() => toggleModal(file)}
                  >
                    {translate("view")}
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => onRemove(idx)}
                  className="text-red-500 hover:underline"
                >
                  {translate("remove")}
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}

      {/* modal to view file receipt by params*/}

      {modalOpen && (
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 overflow-y-auto">
          <div className="relative w-full max-w-2xl p-4">
            <div className="bg-white dark:bg-gray-700 rounded-lg shadow">
              {imageToView && (
                <img
                  src={imageToView}
                  alt="File Preview"
                  className="w-full h-auto rounded-lg s"
                />
              )}
              {documentToView && (
                // eslint-disable-next-line jsx-a11y/iframe-has-title
                <iframe
                  src={documentToView}
                  className="w-full h-[80vh] rounded-lg"
                  controls={false}
                />
              )}
              <div className="flex justify-end p-4">
                <button
                  type="button"
                  className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5"
                  onClick={() => toggleModal(null)}
                >
                  {translate("close")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default FileInput;
